(function($) {
    function init(container) {
        const latitude = parseFloat((container.data('latitude')).toString().replace(/,/g, '.')),
            longitude = parseFloat((container.data('longitude')).toString().replace(/,/g, '.')),
            center = { lat: latitude, lng: longitude };

        var map = new google.maps.Map(container.find('.js-map').get(0), { zoom: 17, center: center });
        var marker = new google.maps.Marker({ position: center, map: map });
    }

    window.initGoogleMap = function() {
        $('.js-map-block').each(function(index, container) {
            init($(container));
        });
    };
})(jQuery);
